<template>
  <div name="mobilenav">
    <div v-if="isExpanded" ref="mobilenav" v-touch:swipe.right="closeTab" class="m-nav" :class="{'is-active': isExpanded}" :style="getNavStyle()">
      <div class="m-nav-content">
        <!-- Search input -->
        <div v-if="primaryMenu" class="search">
          <form tabindex="0" class="search__form" @submit.prevent>
            <input v-model="query"
                   type="text"
                   class="search__form--input"
                   placeholder="What are you looking for?"
                   aria-label="search box"
            >
          </form>
          <button v-if="query && query.length > 0" @click="query = ''">
            <Cross class="search__icon" />
          </button>
        </div>

        <div v-if="query && query.length > 0">
          <algolia-search-columns :query="query" class="search-box" />
        </div>

        <div v-if="query && query.length === 0 || !query">
          <!-- Top Menu -->
          <ul v-if="primaryMenu" class="m-nav__list">
            <li v-for="(item, index) in HamburgerContent" :key="index" class="m-nav__list--item uppercase" @click="selectedMenu = item, primaryMenu = false">
              <app-link :id="item.linkId" :class="{ 'submenu' : item.submenu }" :type="item.linkType">
                {{ item.title }}
                <font-awesome-icon v-if="item.submenu" :icon="['fas', 'chevron-right']" class="icon" />
              </app-link>
            </li>
          </ul>

          <!-- Secondary Menus -->
          <div v-if="!primaryMenu && selectedMenu">
            <div class="m-nav__section-title" @click="primaryMenu = true, selectedMenu = null, openSubmenu = null">
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
              <span class="m-nav__section-title--title">{{ selectedMenu.title }}</span>
            </div>
            <div class="m-nav__list">
              <div v-for="(item, index) in selectedMenu.submenu" :key="index" class="m-nav__list--item" :class="{ 'uppercase' : item.submenu }">
                <div @click="toggleSubmenu(index)">
                  <app-link :id="item.linkId" :type="item.linkType" :class="{ 'submenu heavy' : item.submenu }">
                    {{ item.title }}
                    <font-awesome-icon v-if="item.submenu" :icon="['fas', 'chevron-down']" :class="{ 'reverse' : openSubmenu == index }" class="icon" />
                  </app-link>
                </div>
                <div v-if="item.submenu" :id="`submenu-${index}`" ref="submenu" class="m-nav__list--item_links">
                  <div v-for="(link, i) in item.submenu" :key="i" class="m-nav__list--item_links-link">
                    <a v-if="link.url" :href="link.url">
                      {{ link.title }}
                    </a>
                    <app-link v-else :id="link.linkId" :type="link.linkType">
                      {{ link.title }}
                    </app-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="m-nav-enquiry">
        <app-link id="24" type="page">
          send your enquiry
        </app-link>
      </div>
    </div>
  </div>
</template>

<script>
import translateUrl from '../../mixins/translateUrl';
import closeTab from '../../mixins/closeTab';
import HamburgerContent from './Tabs/HamburgerContent';
import AlgoliaSearchColumns from './AlgoliaSearch/AlgoliaSearchColumns.vue';
import Cross from '../icons/Cross.vue';

export default {
  components: {
    AlgoliaSearchColumns,
    Cross,
  },
  mixins: [translateUrl, closeTab],
  props: {
    expanded: { type: Boolean },
  },
  data() {
    return {
      HamburgerContent,
      isLandscape: false,
      selectedMenu: null,
      primaryMenu: true,
      openSubmenu: null,
      query: null,
      showReset: false,
    };
  },
  computed: {
    isLoggedIn(e) {
      return this.$store.getters['users/loggedInUser'] || false;
    },
    isExpanded() {
      if (this.$store.getters['common/getCurrentSection'] === 'Menumobile') {
        return true;
      }
      return false;
    },
    windowHeight() {
      return window.innerHeight;
    },
    windowScroll() {
      return window.scrollY;
    },
    searchWidth() {
      return this.$store.getters['common/getSearchWidth'];
    },
    menuOpen() {
      return this.expanded;
    },
  },
  watch: {
    menuOpen(val) {
      if (val == false) this.primaryMenu = true;
    },
    windowScroll() {
      this.getNavStyle();
    },
    $route() {
      this.selectedMenu = null;
      this.primaryMenu = true;
      this.openSubmenu = null;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('users/logOut');
    },
    preventFormSubmit() {
    },
    getNavStyle() {
      const height = this.windowHeight ? `${this.windowHeight}px` : '0px';
      const top = 56;
      return {
        height: `${height}`,
        top: `${top}px`,
      };
    },
    langChange(event) {
      Localize.setLanguage(event.target.value);
    },
    toggleSubmenu(index) {
      const allSections = this.$refs.submenu;
      this.openSubmenu == index ? this.openSubmenu = null : this.openSubmenu = index;
      const section = document.getElementById(`submenu-${index}`);
      if (section.style.maxHeight) {
        section.style.maxHeight = null;
      } else {
        allSections.forEach((sec) => {
          sec.style.maxHeight = null;
        });
        section.style.maxHeight = `${section.scrollHeight}px`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/_config.scss";

  body {
    overflow: hidden;
  }

  .m {
    &-nav {
      padding: 0.625rem;
      background: $stoneWhite;
      display: block;
      position: fixed;
      right: 0;
      z-index: 100;
      overflow-x: hidden; /* Disable horizontal scroll */
      overflow-y: auto;
      @media (min-width: 665px) {
        top: 92px;
      }
      &.is-active {
        height: 100% !important;
        width: 100% !important;
        z-index: 3002 !important;
      }
      &-content {
        display: flex;
        flex-direction: column;
        padding-bottom: 80px;
      }
      &__list {
        padding: 40px 20px 80px;
        &--item {
          font-size: 14px;
          margin-bottom: 16px;
          & .submenu {
            display: flex;
            justify-content: space-between;
            &.heavy {
              font-weight: 500;
            }
          }
          & a {
            width: 100%;
            display: block;
            color: inherit;
          }
          &_links {
            text-transform: none;
            font-size: 14px;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.2s ease-out;
            &-link {
              margin: 16px 0;
            }
          }
        }
      }
      &__section-title {
        text-transform: uppercase;
        margin-left: 20px;
        margin-top: 20px;
        font-size: 12px;
        display: flex;
        align-items: center;
        &--title {
          margin-left: 14px;
          font-weight: 500;
          font-size: 12px;
        }
      }
    }
  }

.search {
  padding: 20px;
  padding-bottom: 0;
  position: relative;
  &__form {
    height: 48px;
    &--input {
      width: 100%;
    }
  }
  &-box {
    padding-bottom: 120px;
  }
  &__icon {
    position: absolute;
    top: 33px;
    right: 28px;
  }
}

.icon {
  transition: all 0.5s ease;
  &.reverse {
    transform: rotate(180deg);
  }
}

.navbar-search-back {
  height: 30px;
  color: $echo-blue;
  font-weight: 500;
  display: flex;
  align-items: center;
  &-icon {
    width: 7px;
    height: 9px;
    // margin: 9px 6px 6px 0;
    background-color: $echo-blue;
    display: inline;
  }
}

.m-nav-enquiry {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 64px;
  // z-index: 200;
  background-color: $darkBlack;
  color: $stoneLight;
  width: 100%;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  & a {
    color: inherit;
  }
}

</style>
